import { useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Gallery } from "@/components/Gallery";
import { About } from "@/components/About";
import { Booking } from "@/components/Booking";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import Admin from "@/pages/Admin";

const Home = () => {
  const bookingRef = useRef(null);

  const scrollToBooking = () => {
    const el = document.getElementById("book");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <Header onBook={scrollToBooking} />
      <Hero onBook={scrollToBooking} />
      <Marquee />
      <Services onBook={scrollToBooking} />
      <Gallery />
      <About />
      <Booking formRef={bookingRef} />
      <Contact />
      <Footer onBook={scrollToBooking} />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          className: "!bg-[#121212] !border !border-[#27272A] !text-white !rounded-none",
        }}
      />
    </div>
  );
}

export default App;
